export const formatMobileNumber = (mobileNum: any) => {
  if (mobileNum?.startsWith('0')) {
    const preDefiendProtocol = `971${mobileNum?.slice(1)}`;
    return preDefiendProtocol?.replaceAll(' ', '').replaceAll('+', '');
  }
  return mobileNum?.replaceAll(' ', '').replaceAll('+', '');
};
